import web3 from 'web3'

export const shortenAddress = (address = '', chars = 4) => {
  if (!web3.utils.isAddress(address)) return null
  return `${address.substring(0, chars + 2)}...${address.substring(address.length - chars)}`
}

export default { shortenAddress }
